import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
  Box,
  Card,
  CardContent,
  Typography,
  Button,
  Stack,
} from '@mui/material';

const NotFound = ({ session }) => {
  const homePath = session?.uid ? '/' : '/login';

  return (
    <Box
      sx={{
        minHeight: '70vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        px: 2,
      }}
    >
      <Card sx={{ maxWidth: 480, width: '100%' }}>
        <CardContent>
          <Stack spacing={1.5}>
            <Typography variant="h3" component="h1">
              404
            </Typography>
            <Typography variant="h6">Page not found</Typography>
            <Typography variant="body2" color="text.secondary">
              The page you are looking for doesn&apos;t exist or has been moved.
            </Typography>
            <Button
              component={RouterLink}
              to={homePath}
              variant="contained"
              color="primary"
              sx={{ alignSelf: 'flex-start', mt: 1 }}
            >
              Go to home
            </Button>
          </Stack>
        </CardContent>
      </Card>
    </Box>
  );
};

export default NotFound;
